<template>
  <div class="container w100 relative-container">
    <div class="padded">
      <wrap-container class="w50-fixed">
        <form-validator>
          <step-header v-if="!embeded" />
          <wrap-container>
            <section-label>
              <p>
                ¿Sos una Persona Expuesta Políticamente (PEP)?
                <help-tooltip
                  mensaje="Son personas que se desempeñan en cargos políticos o tienen vínculos familiares o de amistad con alguien que si lo hace."
                />
              </p>
            </section-label>
            <custom-input-group
              :vertical="true"
              v-model="model.pep"
              name="pep"
              :required="true"
            >
              <radio-item
                class="radio-button"
                optionValue="0"
                label="No"
                name="pep"
                quantumObfuscate
              />
              <radio-item
                class="radio-button"
                optionValue="1"
                label="Si"
                name="pep"
                quantumObfuscate
              />
            </custom-input-group>
          </wrap-container>

          <wrap-container>
            <section-label class="label">
              <p data-obfuscate>
                ¿Sos Sujeto Obligado?
                <help-tooltip
                  mensaje="Son personas que, por su actividad, pueden estar expuestas al lavado de dinero u otros activos."
                />
              </p>
            </section-label>
            <custom-input-group
              :vertical="true"
              v-model="model.sujetoObligado"
              :required="true"
              name="sujeto-obligado"
            >
              <radio-item
                class="radio-button"
                optionValue="0"
                label="No"
                name="sujeto-obligado"
                quantumObfuscate
              />
              <radio-item
                class="radio-button"
                optionValue="1"
                label="Si"
                name="sujeto-obligado"
                quantumObfuscate
              />
            </custom-input-group>
          </wrap-container>

          <wrap-container v-if="model.sujetoObligado === '1'">
            <work-activity-sujeto-obligado
              :required="true"
              analyticsName="actividad sujeto obligado"
              v-model="model.actividadSujetoObligado"
              quantumObfuscate
            />
          </wrap-container>

          <wrap-container>
            <section-label class="label">
              <p data-obfuscate>
                ¿Tenés obligaciones tributarias fuera de Argentina?
                <help-tooltip
                  mensaje="Son las personas que pagan, o debiesen pagar, impuestos en el extranjero. "
                />
              </p>
            </section-label>
            <custom-input-group
              :vertical="true"
              v-model="model.fatca"
              :required="true"
              name="fatca"
            >
              <radio-item
                class="radio-button"
                optionValue="0"
                label="No"
                name="fatca"
                quantumObfuscate
              />
              <radio-item
                class="radio-button"
                optionValue="1"
                label="Si"
                name="fatca"
                quantumObfuscate
              />
            </custom-input-group>
          </wrap-container>

          <step-navigator
            v-model="model"
            store-action="DO_INFORMACION_ADICIONAL"
            :routerPush="false"
            analyticsName="continuar"
          />
        </form-validator>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepHeader from "@/components/core/StepHeader";
import SectionLabel from "@/components/core/SectionLabel";
import HelpTooltip from "@/components/core/HelpTooltip";
import WorkActivitySujetoObligado from "@/components/core/WorkActivitySujetoObligado";
import RadioItem from "@/components/core/custom/RadioItem";

import CustomInputGroup from "@/components/core/custom/CustomInputGroup";
import StepNavigator from "@/components/core/StepNavigator";
export default {
  name: "InformacionAdicional",
  components: {
    WrapContainer,
    FormValidator,
    StepHeader,
    SectionLabel,
    HelpTooltip,
    RadioItem,

    CustomInputGroup,
    WorkActivitySujetoObligado,
    StepNavigator
  },
  props: {
    embeded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: this.$store.getters.getInformacionAdicional()
    };
  }
};
</script>

<style scoped>
.cobranding-logo-header {
  top: 36px;
}
.label {
  display: inline-block;
  margin-bottom: 16px;
}
.label p {
  margin: 0;
}
.radio-button.input-container {
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  width: 100%;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
  }
}
</style>
